/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { Button, Dimmer, Loader, Segment, Table } from "semantic-ui-react";
import { TextField } from "@mui/material";
import { selectCurrentUserAdmin, selectCurrentUserApiToken } from "../slices/currentUser/currentUserSlice";
import { changeBrowserTabTitle } from "../slices/browserTabTitle/browserTabTitleSlice";
import { handleWheel, handleKeyDown } from "../functions/eventHandlers";
import SimpleResourceFieldViewer from "../resourceComponents/SimpleResourceFieldViewer";
import CodeSystemTermProgressTable from "./CodeSystemTermProgressTable";
import axios from "axios";
import server_config from '../ServerConfiguration';

const fevir_node_server_address = server_config["fevir_node_server_address"];

const errorsTableHeaderStyle = { backgroundColor: "#FABEBE" };
const errorsTableCellStyle = { backgroundColor: "#FAEAEA" };
const feedbackTableHeaderStyle = { backgroundColor: "#C0FAC0" };
const feedbackTableCellStyle = { backgroundColor: "#F2FDF2" };
const sevcoTableHeaderStyle = { backgroundColor: "#E2DDEF" };
const sevcoTableCellStyle = { backgroundColor: "#F6F4FA" };
const gradeTableHeaderStyle = { backgroundColor: "#EFE2DD" };
const gradeTableCellStyle = { backgroundColor: "#FAF6F4" };

const UserListTable = ({ userList, tableHeaderStyle, tableCellStyle }) => {
    return <Table>
        <Table.Header>
            <Table.Row>
                <Table.HeaderCell style={tableHeaderStyle}>User ID</Table.HeaderCell>
                <Table.HeaderCell style={tableHeaderStyle}>Username</Table.HeaderCell>
                <Table.HeaderCell style={tableHeaderStyle}>Date Joined</Table.HeaderCell>
                <Table.HeaderCell style={tableHeaderStyle}>Notification Email</Table.HeaderCell>
            </Table.Row>
        </Table.Header>
        <Table.Body>
            {userList?.map((user, userIndex) => {
                return <Table.Row key={userIndex}>
                    <Table.Cell style={tableCellStyle}>{user.userid}</Table.Cell>
                    <Table.Cell>{user.name}</Table.Cell>
                    <Table.Cell>{user.datecreated}</Table.Cell>
                    <Table.Cell>
                        {user.notificationemail &&
                            <a href={"mailto:" + user.notificationemail}
                                target="_blank" rel="noopener noreferrer">{user.notificationemail}</a>}
                    </Table.Cell>
                </Table.Row>
            })}
        </Table.Body>
    </Table>;
}

const ErrorsTable = ({ errorsFromServer, tableHeaderStyle, tableCellStyle }) => {
    return <>
        <Table>
            <Table.Header>
                <Table.Row>
                    <Table.HeaderCell style={tableHeaderStyle}>Tool</Table.HeaderCell>
                    <Table.HeaderCell style={tableHeaderStyle}>Grouping ID</Table.HeaderCell>
                    <Table.HeaderCell style={tableHeaderStyle}>Type of Call</Table.HeaderCell>
                    <Table.HeaderCell style={tableHeaderStyle}>Error first occurred</Table.HeaderCell>
                    <Table.HeaderCell style={tableHeaderStyle}>Last occurrence</Table.HeaderCell>
                    <Table.HeaderCell style={tableHeaderStyle}>Occurrences</Table.HeaderCell>
                </Table.Row>
            </Table.Header>
            <Table.Body>
                {errorsFromServer.filter(error => error.lastoccurred > "2025-04-30").map((error, errorIndex) => {
                    return <Table.Row key={errorIndex}>
                        <Table.Cell style={tableCellStyle}>{error.tool}</Table.Cell>
                        <Table.Cell style={tableCellStyle}>{error.groupingidentifier}</Table.Cell>
                        <Table.Cell>
                            {(error.servercalltype === "get" || error.servercalltype === "api") && "API Call"}
                        </Table.Cell>
                        <Table.Cell>{error.datecreated}</Table.Cell>
                        <Table.Cell>{error.lastoccurred}</Table.Cell>
                        <Table.Cell>{error.occurrencecounter}</Table.Cell>
                    </Table.Row>
                })
                }
            </Table.Body>
        </Table>
    </>
}

const FeedbackTable = ({ feedbackFromServer, tableHeaderStyle, tableCellStyle }) => {
    return <>
        <Table>
            <Table.Header>
                <Table.Row>
                    <Table.HeaderCell style={tableHeaderStyle}>Title</Table.HeaderCell>
                    <Table.HeaderCell style={tableHeaderStyle}>Date Created</Table.HeaderCell>
                    <Table.HeaderCell style={tableHeaderStyle}>User ID</Table.HeaderCell>
                    <Table.HeaderCell style={tableHeaderStyle}>Status</Table.HeaderCell>
                </Table.Row>
            </Table.Header>
            <Table.Body>
                {feedbackFromServer.filter(feedback => feedback.datecreated > "2025-04-08")
                    .map((feedback, feedbackIndex) => {
                        return <Table.Row key={feedbackIndex}>
                            <Table.Cell style={tableCellStyle}>
                                <Link to={`/resources/ArtifactAssessment/${feedback.id}`}>{feedback.title}</Link>
                            </Table.Cell>
                            <Table.Cell>{feedback.datecreated}</Table.Cell>
                            <Table.Cell>{feedback.resourcecreatoruserid}</Table.Cell>
                            <Table.Cell>{feedback.status}</Table.Cell>
                        </Table.Row>
                    })
                }
            </Table.Body>
        </Table>
    </>
}

const massConvertCitations = async (apiToken) => {
    let response = await axios({
        method: 'POST',
        url: fevir_node_server_address,
        timeout: 120000,
        data: {
            'functionid': 'massconvertcitation',
            'apiToken': apiToken
        },
    }).then((resp) => {
        if (resp?.data) {
            return resp.data;
        }
        console.log("NO RESPONSE from massconvertcitation call");
    }).catch((error) => { console.log(error); });
}

const getFeedback = async (setAdminState, apiToken) => {
    if (!apiToken) {
        console.log("no apiToken");
        return null;
    }
    console.log("CALLING SERVER with getallfeedback");
    let response = await axios({
        method: 'POST',
        url: fevir_node_server_address,
        timeout: 120000,
        data: {
            'functionid': 'getallfeedback',
            'apiToken': apiToken
        },
    }).then((resp) => {
        if (resp?.data) {
            return resp.data;
        }
        console.log("NO RESPONSE from getallfeedback call");
    }).catch((error) => { console.log(error); });
    console.log("CALLING SERVER with getsevcofeedback");
    let sevcoResponse = await axios({
        method: 'POST',
        url: fevir_node_server_address,
        timeout: 120000,
        data: {
            'functionid': 'getsevcofeedback',
            'apiToken': apiToken
        },
    }).then((resp) => {
        if (resp?.data) {
            return resp.data;
        }
        console.log("NO RESPONSE from getsevcofeedback call");
    }).catch((error) => { console.log(error); });
    let feedbackFromServer;
    let sevcoFeedbackFromServer;
    if (response?.success && response.feedbackFromServer) {
        feedbackFromServer = response.feedbackFromServer;
        feedbackFromServer.sort((a, b) => (a.lastmodified < b.lastmodified) ? 1 : -1);
    } else {
        alert("Unsuccessful response from getallfeedback call.");
    }
    if (sevcoResponse?.success && sevcoResponse.feedbackFromServer) {
        sevcoFeedbackFromServer = sevcoResponse.feedbackFromServer;
        sevcoFeedbackFromServer.sort((a, b) => (a.lastmodified < b.lastmodified) ? 1 : -1);
    } else {
        alert("Unsuccessful response from getsevcofeedback call.");
    }
    setAdminState(prevState => {
        return { ...prevState, "feedbackFromServer": feedbackFromServer, "sevcoFeedbackFromServer": sevcoFeedbackFromServer, "feedbackLoaded": true };
    });
};

const getErrors = async (setAdminState, apiToken) => {
    if (!apiToken) {
        console.log("no apiToken");
        return null;
    }
    console.log("CALLING SERVER with geterrors");
    let response = await axios({
        method: 'POST',
        url: fevir_node_server_address,
        timeout: 120000,
        data: {
            'functionid': 'geterrors',
            'apiToken': apiToken
        },
    }).then((resp) => {
        if (resp?.data) {
            return resp.data;
        }
        console.log("NO RESPONSE from geterrors call");
    }).catch((error) => { console.log(error); });
    if (response?.success && response.errorsFromServer) {
        let errorsFromServer = response.errorsFromServer;
        errorsFromServer.sort((a, b) => (a.lastoccurred < b.lastoccurred) ? 1 : -1);
        setAdminState(prevState => {
            return { ...prevState, "errorsFromServer": errorsFromServer, "errorsLoaded": true };
        });
    } else {
        alert("Unsuccessful response from geterrors call.");
    }
};

const getUsersInVotingGroups = async (setAdminState, apiToken) => {
    if (!apiToken) {
        console.log("no apiToken");
        return null;
    }
    let sevcoExpertWorkingGroupUsers = [];
    let gradeExpertWorkingGroupUsers = [];
    let gradeTermProgress;
    let sevcoVotersLoaded = false;
    let gradeVotersLoaded = false;
    //    let gradeTermProgressLoaded = false;
    try {
        console.log("CALLING SERVER with getusersinvotingpermissiongroup");
        let response = await axios({
            method: 'POST',
            url: fevir_node_server_address,
            timeout: 120000,
            data: {
                'functionid': 'getusersinvotingpermissiongroup',
                'apiToken': apiToken,
                'aboutformstateid': "27270"
            },
        }).then((resp) => {
            if (resp?.data) {
                return resp.data;
            }
            console.log("NO RESPONSE from getusersinvotingpermissiongroup call");
        }).catch((error) => { console.log(error); });
        if (response?.success) {
            sevcoExpertWorkingGroupUsers = response.votinggroupusers;
            sevcoVotersLoaded = true;
        } else {
            alert("Unsuccessful RESPONSE from getusersinvotingpermissiongroup call");
        }
    } catch (e) {
        console.log("ERROR loading SEVCO voters");
        console.log(e);
    }
    try {
        console.log("CALLING SERVER with getusersinvotingpermissiongroup");
        let response = await axios({
            method: 'POST',
            url: fevir_node_server_address,
            timeout: 120000,
            data: {
                'functionid': 'getusersinvotingpermissiongroup',
                'apiToken': apiToken,
                'aboutformstateid': "27833"
            },
        }).then((resp) => {
            if (resp?.data) {
                return resp.data;
            }
            console.log("NO RESPONSE from getusersinvotingpermissiongroup call");
        }).catch((error) => { console.log(error); });
        if (response.success) {
            gradeExpertWorkingGroupUsers = response.votinggroupusers;
            gradeVotersLoaded = true;
        }
    } catch (e) {
        console.log("ERROR loading GRADE voters");
        console.log(e);
    }
    /** THIS PORTION COMMENTED OUT DUE TO NOT GETTING SUCCESSFUL RESPONSE FROM SERVER
    try {
        console.log("CALLING SERVER with gettermcountincodesystem");
        let response = await axios({
            method: 'POST',
            url: fevir_node_server_address,
            timeout: 120000,
            data: {
                'functionid': 'gettermcountincodesystem',
                'apiToken': apiToken,
                'aboutformstateid': "27833"
            },
        }).then((resp) => {
            if (resp?.data) {
                return resp.data;
            }
            console.log("NO RESPONSE from gettermcountincodesystem call");
        }).catch((error) => { console.log(error); });
        if (response.success) {
            gradeTermProgress = response.termcountinfo;
            gradeTermProgressLoaded = true;
        }
    } catch (e) {
        console.log("ERROR loading GRADE term progress");
        console.log(e);
    }
*/
    sevcoExpertWorkingGroupUsers.sort((a, b) => {
        if (b.datecreated > a.datecreated) {
            return 1;
        } else if (b.datecreated < a.datecreated) {
            return -1;
        } else {
            return 0;
        }
    });
    gradeExpertWorkingGroupUsers.sort((a, b) => {
        if (b.datecreated > a.datecreated) {
            return 1;
        } else if (b.datecreated < a.datecreated) {
            return -1;
        } else {
            return 0;
        }
    });

    setAdminState(prevState => {
        return {
            ...prevState,
            "sevcoExpertWorkingGroupUsers": sevcoExpertWorkingGroupUsers,
            "gradeExpertWorkingGroupUsers": gradeExpertWorkingGroupUsers,
            "gradeTermProgress": gradeTermProgress,
            "sevcoVotersLoaded": sevcoVotersLoaded,
            "gradeVotersLoaded": gradeVotersLoaded,
            //      "gradeTermProgressLoaded": gradeTermProgressLoaded
        };
    });
};

const recreateResourceListIndex = async (apiToken) => {
    if (!apiToken) {
        console.log("no apiToken");
        return null;
    }
    console.log("CALLING SERVER with recreateresourcelistindex");
    let response = await axios({
        method: 'POST',
        url: fevir_node_server_address,
        timeout: 120000,
        data: {
            'functionid': 'recreateresourcelistindex',
            'apiToken': apiToken
        },
    }).then((resp) => {
        if (resp?.data) {
            return resp.data;
        }
        console.log("NO RESPONSE from recreateresourcelistindex call");
    }).catch((error) => { console.log(error); });
    if (response) {
        alert(JSON.stringify(response));
    } else {
        alert("The process to recreate the resource list index database is underway. It may take up to 10 minutes or more.");
    }
}

const refreshSearchIndex = async (apiToken) => {
    if (!apiToken) {
        console.log("no apiToken");
        return null;
    }
    console.log("CALLING SERVER with refreshsearchindex");
    let response = await axios({
        method: 'POST',
        url: fevir_node_server_address,
        timeout: 120000,
        data: {
            'functionid': 'refreshsearchindex',
            'apiToken': apiToken
        },
    }).then((resp) => {
        if (resp?.data) {
            return resp.data;
        }
        console.log("NO RESPONSE from refreshsearchindex call");
    }).catch((error) => { console.log(error); });
    if (response) {
        alert(JSON.stringify(response));
    } else {
        alert("No response from server.");
    }
}

const getFevirIndexEntry = async (foi, setFoiForIndexState, apiToken) => {
    if (!foi) {
        console.log("no foi");
        return null;
    }
    if (!apiToken) {
        console.log("no apiToken");
        return null;
    }
    console.log("CALLING SERVER with getfevirindexentry");
    let response = await axios({
        method: 'POST',
        url: fevir_node_server_address,
        timeout: 120000,
        data: {
            'functionid': 'getfevirindexentry',
            'apiToken': apiToken,
            'foi': foi
        },
    }).then((resp) => {
        if (resp?.data) {
            return resp.data;
        }
        console.log("NO RESPONSE from getfevirindexentry call");
    }).catch((error) => { console.log(error); });

    if (response?.success && response.fevirIndexEntry) {
        setFoiForIndexState(prevState => {
            return { ...prevState, "fevirIndexEntry": response.fevirIndexEntry }
        })
    }
}

// eslint-disable-next-line no-empty-pattern
const AdminPage = ({ }) => {

    const isAdmin = useSelector(selectCurrentUserAdmin);
    const apiToken = useSelector(selectCurrentUserApiToken);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [adminState, setAdminState] = useState({
        "loading": true,
        "startedToLoad": true,
        "feedbackLoaded": false,
        "errorsLoaded": false,
        "sevcoVotersLoaded": false,
        "gradeVotersLoaded": false,
        "gradeTermProgressLoaded": false,
        "showROBATusers": false,
        "sevcoExpertWorkingGroupUsers": [],
        "enrollmentGroupUsersInfo": undefined,
        "errorsFromServer": []
    });
    const [foiForIndexState, setFoiForIndexState] = useState({ "foi": "", "fevirIndexEntry": "" });

    useEffect(() => {
        dispatch(changeBrowserTabTitle("FEvIR Admin"));
    }, []);

    useEffect(() => {
        if (isAdmin && adminState.startedToLoad) {
            setAdminState(prevState => { return { ...prevState, startedToLoad: false }; });
            getFeedback(setAdminState, apiToken);
            getErrors(setAdminState, apiToken);
            getUsersInVotingGroups(setAdminState, apiToken);
        } else if (isAdmin && adminState.loading &&
            adminState.feedbackLoaded &&
            adminState.errorsLoaded &&
            adminState.sevcoVotersLoaded &&
            adminState.gradeVotersLoaded
        ) {
            setAdminState(prevState => { return { ...prevState, loading: false }; });
        }
    }, [adminState]);

    return <>
        {isAdmin &&
            <div>
                <Segment className={`containerSegment maxRemainderOfPageSegment`} raised>
                    <div>
                        {adminState.loading &&
                            <Dimmer className={"loadingDimmer"} active inverted>
                                <Loader inverted>Loading</Loader>
                            </Dimmer>
                        }
                        <span style={{ width: "100%", textAlign: "center" }}>
                            <h3>Admin Dashboard</h3>
                        </span>
                        <Button style={{ position: "absolute", right: "3px", top: "3px" }}
                            className="formButton negative" content="✖"
                            onClick={() => { navigate("/"); }} />
                        <Button style={{ width: "360px", float: "left" }}
                            className="formButton" content="Recreate Resource List Index"
                            onClick={() => {
                                recreateResourceListIndex();
                            }} />
                        <br /><br />
                        <Button style={{ width: "360px", float: "left" }}
                            className="formButton" content="Refresh Search Index"
                            onClick={() => {
                                refreshSearchIndex();
                            }} />
                        <br /><br />
                        <TextField style={{ width: "480px" }}
                            className="inputField" size="small" variant='outlined'
                            placeholder='Enter FOI for index entry' type='number' inputMode='numeric'
                            value={foiForIndexState.foi}
                            onWheel={handleWheel}
                            onKeyDown={handleKeyDown}
                            onKeyUp={(event) => {
                                if (event.key === 'Enter' && foiForIndexState?.foi) {
                                    getFevirIndexEntry(foiForIndexState.foi, setFoiForIndexState, apiToken);
                                }
                            }}
                            onChange={(e) => {
                                setFoiForIndexState({
                                    "foi": e.target.value, "fevirIndexEntry": ""
                                });
                            }} />
                        <br /><br />
                        <Button style={{ width: "360px", float: "left" }}
                            className="formButton" content="Mass Convert Citations"
                            onClick={() => {
                                massConvertCitations(apiToken);
                            }} />
                        {foiForIndexState.fevirIndexEntry &&
                            <SimpleResourceFieldViewer resource={foiForIndexState.fevirIndexEntry}
                                parentElement={""} />
                        }
                        <br /><br />
                        {adminState.errorsFromServer &&
                            <>
                                <h4 style={{ paddingTop: "0px", marginTop: "0px" }}>Errors</h4>
                                <ErrorsTable errorsFromServer={adminState.errorsFromServer}
                                    tableHeaderStyle={errorsTableHeaderStyle}
                                    tableCellStyle={errorsTableCellStyle} />
                            </>}
                        <br />
                        {adminState.feedbackFromServer && <>
                            <h4 style={{ paddingTop: "0px", marginTop: "0px" }}>Feedback</h4>
                            <FeedbackTable feedbackFromServer={adminState.feedbackFromServer}
                                tableHeaderStyle={feedbackTableHeaderStyle}
                                tableCellStyle={feedbackTableCellStyle} />
                        </>}
                        <br />
                        {adminState.sevcoFeedbackFromServer && <>
                            <h4 style={{ paddingTop: "0px", marginTop: "0px" }}>SEVCO Feedback</h4>
                            <FeedbackTable feedbackFromServer={adminState.sevcoFeedbackFromServer}
                                tableHeaderStyle={feedbackTableHeaderStyle}
                                tableCellStyle={feedbackTableCellStyle} />
                        </>}
                        <br />
                        <h4 style={{ paddingTop: "0px" }}>SEVCO Expert Working Group userlist</h4>
                        <UserListTable userList={adminState.sevcoExpertWorkingGroupUsers}
                            tableHeaderStyle={sevcoTableHeaderStyle}
                            tableCellStyle={sevcoTableCellStyle} />
                        <br />
                        {adminState.gradeTermProgress && <>
                            <h4 style={{ paddingTop: "18px" }}>GRADE terms progress</h4>
                            <CodeSystemTermProgressTable termProgress={adminState.gradeTermProgress}
                                tableHeaderStyle={gradeTableHeaderStyle}
                                tableCellStyle={gradeTableCellStyle}
                                totalText={"GRADE (total)"} />
                        </>}
                        <h4 style={{ paddingTop: "18px" }}>GRADE Expert Working Group userlist</h4>
                        <UserListTable userList={adminState.gradeExpertWorkingGroupUsers}
                            tableHeaderStyle={gradeTableHeaderStyle}
                            tableCellStyle={gradeTableCellStyle} />
                        <br />
                        <br />
                        <br />
                    </div>
                </Segment>
            </div>
        }
    </>
}

export default AdminPage;